"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.ThemeProvider = exports.getPropertiesFromTheme = exports.getTheme = exports.DEFAULT_THEME = void 0;

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _react = _interopRequireWildcard(require("react"));

var _native = require("styled-components/native");

var Themes = _interopRequireWildcard(require("../themes"));

var DEFAULT_THEME = (0, _objectSpread2.default)({}, Themes, {
  Grid: {
    default: {
      spacing: 15
    }
  } // Get a theme property and provide trace info so a developer can see where
  // a particular property is coming from. Use `traceTheme={true}` on the
  // component to show trace.

});
exports.DEFAULT_THEME = DEFAULT_THEME;

var getKeyTrace = function getKeyTrace(themeProps, key, trace) {
  if (themeProps && themeProps.hasOwnProperty(key) && !!themeProps[key]) {
    return (0, _objectSpread2.default)({}, themeProps[key], {
      trace: trace
    });
  } else {
    return {};
  }
};

var getTheme = function getTheme(componentName, props, context) {
  var variants = Array.isArray(props.variant) ? props.variant : [props.variant];
  var theme = (0, _objectSpread2.default)({}, getKeyTrace(DEFAULT_THEME[componentName], 'default', "root/default"), getKeyTrace(context[componentName], 'default', 'context/default'));
  variants.forEach(function (key) {
    theme = (0, _objectSpread2.default)({}, theme, DEFAULT_THEME[componentName] ? getKeyTrace(DEFAULT_THEME[componentName], key, componentName + "/" + key) : {}, context[componentName] ? getKeyTrace(context[componentName], key, "context/" + componentName + "/" + key) : {});
  });

  if (props.traceTheme) {
    /*eslint-disable*/
    console.log('theme', theme);
    /*eslint-enable*/
  }

  return (0, _objectSpread2.default)({}, theme, props.theme || {});
};

exports.getTheme = getTheme;
var ThemeContext = (0, _react.createContext)(DEFAULT_THEME);
var Provider = ThemeContext.Provider;
var REPLACE_EXP = /([a-z])([A-Z])/g;

var camelCaseToDash = function camelCaseToDash(text) {
  return text.replace(REPLACE_EXP, '$1-$2').toLowerCase();
};

var getPropertiesFromTheme = function getPropertiesFromTheme(theme) {
  var keys = Object.keys(theme);
  var props = keys.filter(function (key) {
    return theme[key] !== 'initial' && theme[key] !== 'inherit';
  }).map(function (key) {
    return camelCaseToDash(key) + ": " + theme[key] + ";";
  }).join(' ');
  return props;
};

exports.getPropertiesFromTheme = getPropertiesFromTheme;

var ThemeProvider =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(ThemeProvider, _Component);

  function ThemeProvider() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = ThemeProvider.prototype;

  _proto.render = function render() {
    if (this.props.theme && this.props.theme.styled) {
      return _react.default.createElement(Provider, {
        value: this.props.theme
      }, _react.default.createElement(_native.ThemeProvider, {
        theme: this.props.theme.styled
      }, this.props.children));
    }

    return _react.default.createElement(Provider, {
      value: this.props.theme
    }, this.props.children);
  };

  return ThemeProvider;
}(_react.Component);

exports.ThemeProvider = ThemeProvider;
var _default = ThemeContext;
exports.default = _default;